import z from "zod";

export const E164PhoneNumberSchema = z
  .string()
  .regex(/^\+1\d{10}$/, "Must be a valid E.164-formatted phone number");

export const ShortCodeOrE164PhoneNumberSchema = z
  .string()
  .regex(
    /^(\d{5,6}|\+1\d{10})$/,
    "Must be a valid 5-digit or 6-digit short code or an E.164-formatted US phone number"
  );

export type OverrideFields<
  OriginalFields extends object,
  OverriddenFields extends object,
> = Omit<OriginalFields, keyof OverriddenFields> & OverriddenFields;

export const overrideZodInfer =
  <ZodInferredType extends object>(schema: z.ZodType<ZodInferredType>) =>
  <OverriddenFields extends object>(): z.ZodType<
    OverrideFields<ZodInferredType, OverriddenFields>
  > =>
    schema as unknown as z.ZodType<
      OverrideFields<ZodInferredType, OverriddenFields>
    >;
